import React from "react";

export default function IconLoading() {
  return (
    <div className="icon-loading">
      <div className="icon-loading-bar"></div>
    </div>
  );
}
